(function () {
  var activeDrawer = null;

  function updateTriggerText(trigger, select) {
    var selected = select.options[select.selectedIndex];
    if (selected) trigger.textContent = selected.text;
  }

  function updateDrawerSelection(drawer, select) {
    var selectedValue = select.value;

    drawer.querySelectorAll('.size-picker-drawer__item').forEach(function (item) {
      item.classList.toggle('is-active', item.dataset.value === selectedValue);
    });
  }

  function resetHeaderZIndex() {
    var mainHeader = document.getElementById('main-header');
    var announcementBar = document.getElementById('shopify-section-announcement-bar');
    if (mainHeader) {
      mainHeader.style.zIndex = '30';
      mainHeader.style.transition = '';
    }
    if (announcementBar) {
      announcementBar.style.zIndex = '30';
    }
  }

  function lowerHeaderZIndex() {
    var mainHeader = document.getElementById('main-header');
    var announcementBar = document.getElementById('shopify-section-announcement-bar');
    if (mainHeader) {
      mainHeader.style.transition = 'none';
      mainHeader.style.zIndex = '0';
    }
    if (announcementBar) announcementBar.style.zIndex = '0';
  }

  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.overlay.classList.remove('is-open');
    activeDrawer.drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    resetHeaderZIndex();
    activeDrawer = null;
  }

  function showDrawer(drawerObj) {
    closeDrawer();
    drawerObj.overlay.classList.add('is-open');
    drawerObj.drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    lowerHeaderZIndex();
    activeDrawer = drawerObj;
  }

  function init() {
    document.querySelectorAll('.size-picker__select-wrapper').forEach(function (wrapper) {
      var selectId = wrapper.dataset.for;
      var select = document.getElementById(selectId);
      var trigger = wrapper.querySelector('.size-picker__trigger');
      var container = wrapper.parentNode;
      var overlay = container.querySelector('.size-picker-overlay[data-for="' + selectId + '"]');
      var drawer = container.querySelector('.size-picker-drawer[data-for="' + selectId + '"]');

      if (!select || !trigger || !overlay || !drawer) return;

      var closeBtn = drawer.querySelector('.size-picker-drawer__close');
      var items = drawer.querySelectorAll('.size-picker-drawer__item');

      updateTriggerText(trigger, select);
      updateDrawerSelection(drawer, select);

      wrapper.addEventListener('click', function () {
        showDrawer({ overlay: overlay, drawer: drawer });
      });

      closeBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        closeDrawer();
      });

      overlay.addEventListener('click', closeDrawer);

      items.forEach(function (item) {
        if (item.classList.contains('is-disabled')) return;

        item.addEventListener('click', function () {
          select.value = item.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeDrawer();
        });
      });

      select.addEventListener('change', function () {
        updateTriggerText(trigger, select);
        updateDrawerSelection(drawer, select);
        closeDrawer();
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
